import { render, staticRenderFns } from "./DepartmentFilter.vue?vue&type=template&id=61d8963a&"
import script from "./DepartmentFilter.vue?vue&type=script&lang=js&"
export * from "./DepartmentFilter.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentFilter.vue?vue&type=style&index=0&id=61d8963a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports